import React from 'react';

import { styled } from '@mui/material/styles';

const Container = styled('section')`
  .long-copy {
    margin-bottom: 30px;
  }


  img {
    display: flex;
    justify-self: center;
  }
`;

type Props = {
  className?: string;
};

const Certifications = ({ className }: Props) => (
  <Container className={className} id='certifications'>
    <div className='row'>
      <h2>Certifications & Approvals</h2>
      <p className='long-copy'>
        Coastal Cement is proud to be an AASHTO-tested facility, recognized through their rigorous audit program.
        We are also an approved cement supplier for both the North Carolina (NCDOT) and South Carolina (SCDOT)
        Departments of Transportation. These certifications reflect our ongoing commitment to quality, consistency,
        and regulatory compliance.
      </p>
      <img
        src='images/ProductSealLarge.png'
        alt='AASHTO Datamine Tested Seal'
        className='product-seal'
      />
    </div>
  </Container>
);

export default Certifications;
